export default {
  PORTALS: (state) => {
    return state.portals
  }
}
